import {Component} from "@/event/calendar/dom/Component.ts";
import {DrawingContext} from "@/event/calendar/dom/DrawingContext.ts";
import {insetRect, Rect} from "@/event/calendar/Shapes.ts";

export class FrameComponent extends Component {
	private borderColor: string;

	private left: number;
	private right: number;
	private top: number;
	private bottom: number;
	private radius: number;

	constructor(color:string) {
		super();
		this.borderColor = color;
	}

	withBorderWidth(width: number, radius = 0):FrameComponent {
		this.radius = radius;
		return this.withBorderWidths(width, width, width, width);
	}

	withBorderWidths(top: number, right: number, bottom: number, left: number):FrameComponent {
		this.top = top;
		this.right = right;
		this.bottom = bottom;
		this.left = left;
		return this;
	}

	calculateContentBox(contentWidth: number, contentHeight: number): Rect {
		return { x: this.left, y: this.top, width: contentWidth - this.left - this.right, height: contentHeight - this.top - this.bottom };
	}

    layoutSelf(dc: DrawingContext, contentBox: Rect) {
		// all children placed inside contentBox and dimensions forced to take all available space
		if (this.children) {
			for (let child of this.children) {
				child.x = contentBox.x;
				child.y = contentBox.y;
				child.width = contentBox.width;
				child.height = contentBox.height;
			}
		}
	}

	protected drawChildren(dc: DrawingContext, area:Rect) {
		dc.ctx.strokeStyle = this.borderColor.startsWith("--") ? dc.style.getPropertyValue(this.borderColor) : this.borderColor;
		let roundRect:Path2D;
		if (this.radius > 0) {
			const r = insetRect({x: 0, y: 0, width: this.width, height: this.height}, this.top);
			roundRect = new Path2D();
			roundRect.roundRect(r.x, r.y, r.width, r.height, this.radius);
			dc.ctx.save();
			dc.ctx.clip(roundRect);
		}
		super.drawChildren(dc, area);
		if (this.radius === 0) {
			if (this.top > 0) {
				dc.ctx.beginPath();
				dc.ctx.moveTo(0, this.top / 2);
				dc.ctx.lineTo(this.width, this.top / 2);
				dc.ctx.lineWidth = this.top;
				dc.ctx.stroke();
			}
			if (this.bottom > 0) {
				dc.ctx.beginPath();
				dc.ctx.moveTo(0, this.height - this.bottom / 2);
				dc.ctx.lineTo(this.width, this.height - this.bottom / 2);
				dc.ctx.lineWidth = this.bottom;
				dc.ctx.stroke();
			}
			if (this.left > 0) {
				dc.ctx.beginPath();
				dc.ctx.moveTo(this.left / 2, 0);
				dc.ctx.lineTo(this.left / 2, this.height);
				dc.ctx.lineWidth = this.left;
				dc.ctx.stroke();
			}
			if (this.right > 0) {
				dc.ctx.beginPath();
				dc.ctx.moveTo(this.width - this.right / 2, 0);
				dc.ctx.lineTo(this.width - this.right / 2, this.height);
				dc.ctx.lineWidth = this.right;
				dc.ctx.stroke();
			}
		} else {
			dc.ctx.restore();
			dc.ctx.lineWidth = this.top;
			dc.ctx.stroke(roundRect);
		}
		dc.ctx.lineWidth = 1;
	}
}